
import { Sandpack } from '@codesandbox/sandpack-react';

export default function Edit() {

  const code = `import React from 'react';
import { ReactUtilityTable } from 'react-utility-table';

export default function App() {
  const [mockData, setMockData] = React.useState([
    { first_name: "Roman", credit: 700, last_name: "Reign" },
    { first_name: "Brock", credit: 750, last_name: "Lesnar" },
    { first_name: "John", credit: 700, last_name: "Cena" },
  ]);

  const columns = [
    { title: "Name", field: "first_name", editable: false },
    {
      title: "Credit",
      field: "credit",
      type: "number",
      sorter: (a, b) => a.credit - b.credit,
    },
    {
      title: "Last Name",
      field: "last_name",
      editComponent: (props) => (
        <input
          type="text"
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
        />
      ),
    },
  ];

  // crudIcons={{
  // edit: <span>Edit</span>,
  // cancel: <span>Cancel </span>,
  // deleteIcon: <span>Delete </span>,
  // save: <span>Save </span>
  // }}
  
  //disableCrudTooltip={true}

  const options = {
    tooltipDescText: "Descending Order",
    tooltipAscText: "Ascending Order",
    // actionCellPositonStart: false,
    // deleteRowText: "Are you sure you want to delete this user?",
    // disableCrudTooltip: true,
  };

  const editable = {
    onRowAdd: (newData) =>
      new Promise((resolve) => {
        setTimeout(() => {
          setMockData(prev => [...prev, newData]);
          resolve();
        }, 1000);
      }),

    onRowUpdate: (newData, oldData) =>
      new Promise((resolve, reject) => {
        setTimeout(() => {
          const dataUpdate = [...mockData];
          const index = oldData.tableData.id;

          if (newData.credit === oldData.credit) {
            alert("This is how we can have validations. Example: value of Credit should be different from previous value.");
            reject(); // validation error
            return;
          }

          dataUpdate[index] = newData;
          setMockData(dataUpdate);
          resolve();
        }, 1000);
      }),

    onRowDelete: (oldData) =>
      new Promise((resolve) => {
        setTimeout(() => {
          const dataDelete = [...mockData];
          const index = oldData.tableData.id;
          dataDelete.splice(index, 1);
          setMockData(dataDelete);
          resolve();
        }, 1000);
      }),
  };

  return (
    <div>
      <ReactUtilityTable
        data={mockData}
        columns={columns}
        options={options}
        editable={editable}
        // crudIcons={{
        //   edit: <span>Edit</span>,
        //   cancel: <span>Cancel</span>,
        //   deleteIcon: <span>Delete</span>,
        //   save: <span>Save</span>
        // }}
      />
    </div>
  );
}
`;

  return (
    <>
      <p style={{ margin: "5px 0px" }}>
        <strong>PlayGround for editable: </strong>
        <br />
        <br />
      </p>
      <Sandpack
        template="react"
        files={{
          "/App.js": code,
        }}
        customSetup={{
          dependencies: {
            react: "18.0.0",
            "react-dom": "18.0.0",
            "react-scripts": "5.0.1",
            "react-utility-table": "2.1.5",
          },
        }}
        theme="dark"
        options={{
          showLineNumbers: true,
          editorHeight: 500,
        }}
      />
    </>
  );
}

